import React from 'react';
import style from '../css/HomeBtn.module.css';
import { Link } from 'react-router-dom';

function HomeBtn({ toLink, icon, text }) {
	return (
		<Link to={toLink} className={style.homeBtn}>
			{icon}
			<p className={style.btnstyle}>{text}</p>
		</Link>
	);
}

export default HomeBtn;
